// extracted by mini-css-extract-plugin
export var cardIcon = "_9d-5";
export var checkboxCard = "_9d-0";
export var checkboxCardSelected = "_9d-4";
export var disabled = "_9d-2";
export var interactive = "_9d-1";
export var outerBorder = "_9d-3";
export var spacerMedium = "_9d-8";
export var spacerSmall = "_9d-7";
export var spacerXsmall = "_9d-6";